import { RootState } from '@app/redux/root-reducer';

export const selectSkuState = (store: RootState) => store.skuSlice.sku;
export const selectSkuDetailState = (store: RootState) => store.skuSlice.skuDetail;
export const selectAddSkuState = (store: RootState) => store.skuSlice.addSku;
export const selectUpdateSkuStatusState = (store: RootState) => store.skuSlice.updateSkuStatus;
